import { parseGroupedMessageDate } from '@/utils/parseTime';

type Props = {
  date: string;
};

export default function DateHeader({ date }: Props) {
  return (
    <div className='flex w-full justify-center py-2 select-none'>
      <span className='rounded-xl bg-base-100/60 px-2 py-1 text-body2 desktop:text-sm backdrop-blur-lg'>
        {parseGroupedMessageDate(date)}
      </span>
    </div>
  );
}
